<template>
  <div>
    <Common :importState="importState" :uploadHeaders="uploadHeaders"></Common>
    <el-container>
      <el-aside style="width: 200px;">
        <Menu activeName="1-2"></Menu>
      </el-aside>
      <el-main
        style="display: flex;flex: 1;flex-direction: column;align-items: center;justify-content: center;padding-top: 50px;height: 100vh;">
        <div style="display: flex;flex-direction: row;width: 90%;justify-content: space-between;">
          <el-dropdown size="small" split-button type="primary" :split-button="true" @command="dropdownClick">
            操作
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batch-delete">删除</el-dropdown-item>
              <el-dropdown-item command="export">导出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div>
            <el-button size="small" type="primary" @click="importExcel()">导入</el-button>
          </div>
          <el-form :inline="true" :model="searchParams" class="demo-form-inline" style="margin-left: 20px;">
            <el-form-item label="地点">
              <el-input size="small" v-model="searchParams.name"></el-input>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input size="small" v-model="searchParams.phone_name"></el-input>
            </el-form-item>
            <el-form-item label="客户手机号">
              <el-input size="small" v-model="searchParams.phone"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="getPlaceList">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table border v-loading="loading" :data="placeList" height="300" style="width: 90%;margin: 0 auto;"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column fixed prop="name" label="地点名称" width="180">
          </el-table-column>
          <el-table-column prop="address" label="详细地址" width="280">
          </el-table-column>
          <el-table-column label="客户信息" width="200">
            <template slot-scope="scope" v-if="scope.row.phone_name">
              <el-popover trigger="hover" placement="top">
                <p>姓名: {{ scope.row.phone_name }}</p>
                <p>手机号: {{ scope.row.phone }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.phone_name }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注" width="200">
          </el-table-column>
          <el-table-column prop="create_time" label="创建日期" width="180">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="showPlaceUpdateForm(scope.row)">编辑</el-button>
              <el-popconfirm title="是否移除该地点？" @confirm="deletePlace(scope.row)">
                <el-button slot="reference" type="text" size="small">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 30px;" background layout="total,sizes,prev, pager, next,jumper"
          :page-sizes="[10, 20, 50, 100]" :page-size.sync="searchParams.limit" :current-page.sync="searchParams.page"
          @size-change="getPlaceList" @current-change="getPlaceList" :total="total">
        </el-pagination>
      </el-main>
    </el-container>

    <el-dialog title="修改地点信息" :visible.sync="updateDialogFormVisible" width="40%" :center="true">
      <el-form :model="placeForm">
        <el-form-item label="地点名称" :label-width="formLabelWidth">
          <el-input v-model="placeForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地点地址" :label-width="formLabelWidth">
          <el-input v-model="placeForm.address" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="客户名称" :label-width="formLabelWidth">
          <el-input v-model="placeForm.phone_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="客户手机号" :label-width="formLabelWidth">
          <el-input v-model="placeForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="placeForm.remarks" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdatePlace">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from 'store'
import Menu from '@/components/Menu.vue'
import Common from '@/components/Common.vue'
import {
  DeletePlace,
  BatchDeletePlace,
  GetTeamPlaceList,
  BatchExcelExport,
  UpdatePlace
} from '../api/place.js'

export default {
  name: 'Place',
  components: { Menu, Common },
  data() {
    return {
      searchParams: {
        page: 1,
        limit: 10,
      },
      placeForm: {},
      uploadHeaders: [],
      updateDialogFormVisible: false,
      loading: false,
      formLabelWidth: "100px",
      selectIdArr: [],
      total: 0,
      placeList: [],
      importState: false,
    }
  },
  mounted() {
    this.getPlaceList()
  },
  methods: {
    getPlaceList() {
      let that = this
      this.loading = true
      GetTeamPlaceList(that.searchParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          that.placeList = res.data.list
          that.total = res.data.total
        } else {
          that.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    dropdownClick(command) {
      if (command === 'batch-delete') {
        this.batchDelete()
      } else if (command === 'export') {
        this.batchExport()
      }
    },
    batchExport() {
      let that = this
      let ids = this.selectIdArr.join(',')
      BatchExcelExport({ ids: ids }).then(res => {
        if (res.code === 200) {
          that.$notify({
            type: 'success',
            message: '导出成功'
          })
          window.open(res.data.link)
        } else {
          that.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    importExcel() {
      this.uploadHeaders['Access-Token'] = store.get('token')
      this.importState = true
    },
    batchDelete() {
      let that = this
      if (this.selectIdArr.length <= 0) {
        that.$notify({
          type: 'warning',
          message: "请先选择要删除的地点"
        })
        return
      }
      this.$confirm('批量删除确定', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = this.selectIdArr.join(',')
        BatchDeletePlace({ ids: ids }).then(res => {
          if (res.code === 200) {
            that.$notify({
              type: 'success',
              message: '批量删除成功'
            })
            that.showDetailsDivState = false
            that.getPlaceList()
          } else {
            that.$notify({
              type: 'error',
              message: res.message
            })
          }
        })
      })

    },
    deletePlace(info) {
      let that = this
      DeletePlace({ id: info.id }).then(res => {
        if (res.code === 200) {
          that.$notify({
            type: 'success',
            message: '删除成功'
          })
          that.showDetailsDivState = false
          that.getPlaceList()
        } else {
          that.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    handleSelectionChange(e) {
      let idArr = []
      if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
          idArr.push(e[i].id)
        }
      }
      this.selectIdArr = idArr
    },
    showPlaceUpdateForm(info) {
      this.placeForm = {
        id: info.id,
        name: info.name,
        address: info.address,
        phone_name: info.phone_name,
        phone: info.phone,
        remarks: info.remarks,
      }
      this.updateDialogFormVisible = true
    },
    submitUpdatePlace() {
      let that = this
      UpdatePlace(that.placeForm).then(res => {
        if (res.code === 200) {
          that.$notify({
            type: 'success',
            message: '修改成功',
          })
          that.updateDialogFormVisible = false
          that.getPlaceList()
        } else {
          that.$notify({
            type: 'error',
            message: res.message,
          })
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Place.vue